import BaseUseCase from "../../base_use_case.js.jsx";

class LoadTotalInvestmentsUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/statistics/investments/total`,
      params: params
    }).then((result) => {
      return result
    })
  }
}

const instance = new LoadTotalInvestmentsUseCase();
export default instance;